import React, { useEffect, useRef, useState } from 'react';
import { showErrorToast, showInfoToast } from '../../../utils/toastHelper';
import { useTranslation } from 'react-i18next';
import { exportOrders } from '../services/ordersService';
import Modal from 'react-modal';
import ImportConfirmationModal from './ImportConfirmationModal';
import ConfirmationModal from './ConfirmationModal';
import FileNames from '../../../constants/fileNames';

export default function ImportOrdersModal({
  setImportModal,
  handleImportOrders,
  importLoading,
  type,
}) {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();
  const is4pm = currentHour > 16 || (currentHour === 16 && currentMinutes > 0);
  const isPast1730 =
    currentHour > 17 || (currentHour === 17 && currentMinutes > 30);
  const cutoffTime = type === 'FBZ' ? isPast1730 : is4pm;
  const [file, setFile] = useState(null);
  const [importedData, setImportedData] = useState(null);
  const [importingStatus, setImportingStatus] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const [isFileValidating, setIsFileValidating] = useState(false);
  const [duplicateConfirmationModal, setDuplicateConfirmationModal] =
    useState(false);
  const [confirmationType, setConfirmationType] = useState(false);

  const fileInputRef = useRef(null);
  const { t } = useTranslation('Order');
  const { t: importT } = useTranslation('Import');
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (
        !selectedFile.name.endsWith('.csv') &&
        !selectedFile.name.endsWith('.xlsx')
      ) {
        showErrorToast(importT('PLEASE_SELECT_VALID_FILE'));
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setFile(null);
        return;
      }

      if (selectedFile.size > 2 * 1024 * 1024) {
        showErrorToast(importT('FILE_SIZE_EXCEEDS_LIMIT'));
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setFile(null);
        return;
      }
      setFile(selectedFile);
    }
  };

  const handleDuplicateConfirmation = async (options) => {
    setDuplicateConfirmationModal(false);
    setIsFileValidating(false);
    setConfirmationOpen(true);

    await confirmImport(
      'NO',
      options.allowDeliveryTomorrow ? 'YES' : 'NO',
      options.allowDuplicate ? 'YES' : 'NO',
      false
    );
    setConfirmationOpen(false);
  };

  const handleSubmit = async (e, referenceOnly = false) => {
    e.preventDefault();
    if (!file) {
      showInfoToast(importT('PLEASE_SELECT_FILE_FIRST'));
      return;
    }

    if (referenceOnly) {
      confirmImport('NO', 'YES', 'YES', true);
      return;
    }
    // Confirm import action
    setConfirmationOpen(true);
  };

  const confirmImport = async (
    validationCheck = 'YES',
    allowDeliveryTomorrow = 'NO',
    allowDuplicate = 'NO',
    isReferenceOnly = false
  ) => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    if (validationCheck === 'YES') {
      formData.append('validation_check', validationCheck);
    } else {
      formData.append('allow_duplicate', allowDuplicate);
      if (cutoffTime) {
        formData.append('allow_delivery_tomorrow', allowDeliveryTomorrow);
      } else {
        formData.append('allow_delivery_tomorrow', 'YES');
      }
    }
    formData.append('timezone', timezone);
    formData.append('is_reference_only', isReferenceOnly);
    // 'Checking for duplicate orders and if any order has delivery date tomorrow.'
    setImportingStatus(
      validationCheck === 'YES' && cutoffTime && type !== 'LOGISTICS'
        ? t('CHECKINGFORDUPLICATEORDERSANDIFANYORDERHASDELIVERYDATETOMORROW.')
        : validationCheck === 'YES' && !cutoffTime
          ? t('CHECKINGFORDUPLICATEORDERS.')
          : null
    );

    const response = await handleImportOrders(formData);
    setImportingStatus(null);
    if (response && response.success) {
      if (validationCheck === 'YES') {
        setIsFileValidating(true);

        if (
          (!cutoffTime || response.import_progress.delivery_tmr_rows === 0) &&
          // response.import_progress.invalid_rows === 0 &&
          response.import_progress.duplicate_rows === 0
        ) {
          confirmImport('NO', 'NO', 'NO', false);
          return;
        }
        // else if (
        //   response.import_progress.delivery_tmr_rows === 0 &&
        //   response.import_progress.invalid_rows !== 0 &&
        //   response.import_progress.duplicate_rows === 0
        // ) {

        //   setIsFileValidating(false);

        //   setImportedData(response.import_progress);
        // }
        else {
          setImportedData(response.import_progress);
          const { delivery_tmr_rows, duplicate_rows } =
            response.import_progress;

          setConfirmationType(
            duplicate_rows > 0 && delivery_tmr_rows > 0
              ? 'DUPLICATEANDDELIVERY'
              : duplicate_rows > 0
                ? 'DUPLICATE'
                : delivery_tmr_rows > 0
                  ? 'DELIVERY'
                  : ''
          );
          setDuplicateConfirmationModal(true);
          setConfirmationOpen(false);

          return;
        }

        // 'invalid_rows' => $progress->invalid_rows,
        // 'delivery_tmr_rows' => $progress->delivery_tmr_rows,
        // 'duplicate_rows' => $progress->duplicate_rows,
      } else {
        setIsFileValidating(false);

        setImportedData(response.import_progress);
      }
      // if (response.message === 'delivery_tomorrow') {
      //   setTmrConfirmationModal(true);
      //   return;
      // } else if (response.message === 'no_delivery_tomorrow') {
      //   if (response.import_progress.failed_rows == 0) {
      //     setAllowDeliveryTomorrowUserInput('NO');
      //     confirmImport('NO', 'CHECK');
      //     return;
      //   } else {
      //     setImportedData(response.import_progress);
      //   }
      // } else if (response.message === 'duplicate_order') {
      //   setDuplicateConfirmationModal(true);
      //   return;
      // } else if (response.message === 'no_duplicate_order') {
      //   if (response.import_progress.failed_rows == 0) {
      //     confirmImport(allowDeliveryTomorrowUserInput, 'NO');
      //     return;
      //   } else {
      //     setImportedData(response.import_progress);
      //   }
      // } else {
      //   setImportedData(response.import_progress);
      // }
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setFile(null);
    setConfirmationOpen(false);
  };

  const cancelImport = () => {
    setConfirmationOpen(false);
  };

  const handleDownloadSample = async () => {
    const sampleFileName =
      type === 'FBZ'
        ? FileNames.FBZ_ORDERS_SAMPLE_IMPORT
        : type === 'CATERING'
          ? FileNames.CATERING_ORDERS_SAMPLE_IMPORT
          : FileNames.LOGISTICS_ORDERS_SAMPLE_IMPORT;
    const response = await exportOrders(
      {
        sample: true,
        type: type,
      },
      sampleFileName
    );
  };
  return (
    <div className="import-file modal fade show d-block" id="import-orders">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {importedData ? t('IMPORTDETAILS') : t('IMPORTFILE')}
            </h1>
            <button
              //   type="button"
              className="btn-close"
              onClick={() => {
                setImportModal(false);
              }}
            ></button>
          </div>
          {confirmationOpen ? (
            <div className="modal-body export-import">
              <h5>
                {
                  importingStatus
                    ? importingStatus
                    : t('IMPORTCONFIRMATION', {
                        section: type + ' ' + t('ORDERS'),
                      })
                  // {/* {`We are going to import in the ${FBZ === 0 ? 'Catering' : 'FBZ'} orders section. Please confirm.`} */}
                }
              </h5>
              <div className="d-flex justify-content-between">
                <button
                  onClick={() => {
                    if (type === 'LOGISTICS') {
                      // confirmImport('NO', 'YES', 'YES', 'FALSE');
                      confirmImport('YES', 'YES');
                    } else {
                      confirmImport('YES');
                    }
                  }}
                  className={`import-btn mt-1 ${importLoading ? 'disable-btn' : ''}`}
                  disabled={importLoading}
                >
                  {t('YESPROCEED')}
                </button>
                <button
                  onClick={cancelImport}
                  disabled={importLoading}
                  className={`cancel ${importLoading ? 'disable-btn' : ''}`}
                >
                  {t('NOCANCEL')}
                </button>
              </div>
            </div>
          ) : importedData ? (
            <div className="modal-body">
              <div className="product-inner">
                <div className="import-status mt-3">
                  <h3 className="import-head">{t('IMPORTSTATUS')}</h3>
                  {isFileValidating ? (
                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('STATUS')}:</strong>{' '}
                          {t(importedData.status)}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">
                            {t('PROCESSEDROWS')}:
                          </strong>{' '}
                          {importedData.processed_rows}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('VALIDROWS')}:</strong>{' '}
                          {importedData.valid_rows}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('INVALIDROWS')}:</strong>{' '}
                          {/* {type === 'LOGISTICS'
                            ? importedData.failed_rows
                            : importedData.invalid_rows} */}
                          {importedData.invalid_rows}
                        </p>
                      </div>
                      {cutoffTime && type !== 'LOGISTICS' && (
                        <div className="col-md-6">
                          <p>
                            <strong className="pe-2">
                              {t('TOMORROWDELIVERYROWS')}:
                            </strong>{' '}
                            {importedData.delivery_tmr_rows}
                          </p>
                        </div>
                      )}
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">
                            {t('DUPLICATEORDERROWS')}:
                          </strong>{' '}
                          {importedData.duplicate_rows}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('STATUS')}:</strong>{' '}
                          {t(importedData.status)}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">
                            {t('PROCESSEDROWS')}:
                          </strong>{' '}
                          {importedData.processed_rows}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">
                            {t('SUCCESSFULROWS')}:
                          </strong>{' '}
                          {importedData.success_rows}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('VALIDROWS')}:</strong>{' '}
                          {importedData.valid_rows}
                        </p>
                      </div>
                      {/* <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('FAILEDROWS')}:</strong>{' '}
                          {importedData.failed_rows}
                        </p>
                      </div> */}
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('INVALIDROWS')}:</strong>{' '}
                          {/* {type === 'LOGISTICS'
                            ? importedData.failed_rows
                            : importedData.invalid_rows} */}
                          {importedData.invalid_rows}
                        </p>
                      </div>
                    </div>
                  )}

                  {importedData.error_message && (
                    <div className="errors">
                      <h4>{t('ERRORS')}:</h4>
                      <ul>
                        {importedData.error_message
                          .split(',')
                          .map((error, index) => (
                            <li key={index}>{error.trim()}</li>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => setImportModal(false)}
                  className={`import-btn`}
                >
                  {t('CLOSE')}
                </button>
              </div>
            </div>
          ) : (
            <div className="modal-body">
              <div className="product-inner">
                <label>
                  <form action="">
                    <img src="images/file-download-import-icon 1.svg" alt="" />
                    <p>{t('UPLOADFILE')}...</p>
                    <input
                      ref={fileInputRef}
                      type="file"
                      name="file"
                      id="file"
                      onChange={handleFileChange}
                      accept=".xls,.xlsx,.csv"
                    />
                  </form>
                </label>
                {file && (
                  <div className="file-name-display mt-3">
                    <p>
                      <strong>{t('SELECTEDFILE')}:</strong> {file.name}
                    </p>
                  </div>
                )}
                <div className="file-name-display mt-3">
                  <p>
                    <button
                      className="btn btn-link"
                      onClick={handleDownloadSample}
                    >
                      {t('DOWNLOADSAMPLE')}
                    </button>
                  </p>
                </div>

                <div className="d-flex justify-content-between py-3 file-size">
                  <p className="mb-0">{t('SUPPORTEDFORMAT')}: xlsx</p>
                  <p className="mb-0">{t('MAXIMUMSIZE')}: 2MB</p>
                </div>
                <button
                  type="button"
                  onClick={(e) => handleSubmit(e, false)}
                  className={`import-btn mt-1 ${importLoading ? 'disable-btn' : ''}`}
                  disabled={importLoading}
                >
                  {importLoading ? t('IMPORTING') + '...' : t('IMPORT')}
                </button>
                {type === 'CATERING' && (
                  <button
                    type="button"
                    onClick={(e) => handleSubmit(e, true)}
                    className={`import-btn mt-1 ${importLoading ? 'disable-btn' : ''}`}
                    disabled={importLoading}
                  >
                    {importLoading
                      ? t('IMPORTING') + '...'
                      : t('IMPORTREFERENCENUMBER')}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        isOpen={duplicateConfirmationModal}
        onRequestClose={() => setDuplicateConfirmationModal(false)}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        overlayClassName={`modal-overlay add  import-confirmation-modal`}
        portalClassName="add view-modal cutoff"
      >
        <ImportConfirmationModal
          type={type}
          setDuplicateConfirmationModal={setDuplicateConfirmationModal}
          handleDuplicateConfirmation={handleDuplicateConfirmation}
          confirmationType={confirmationType}
          importedData={importedData}
          cutoffTime={cutoffTime}
        />
      </Modal>
      {/* <Modal
        isOpen={tmrConfirmationModal}
        onRequestClose={() => setTmrConfirmationModal(false)}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        overlayClassName={`modal-overlay add `}
        portalClassName="add cut-off"
      >
        <ConfirmationModal
          setConfirmationModal={setTmrConfirmationModal}
          selectedOrdersEdit={''}
          actionType={'Import'}
          onSuccess={handleTmrConfirmationModalSuccess}
          onCancel={handleTmrConfirmationModalCancel}
        />
      </Modal> */}
    </div>
  );
}
